const Footer = () => {
  const footerLinkStyles = 'myl-font-semibold myl-text-secondary-2 hover:myl-underline';
  return (
    <footer
      data-testid="login-footer"
      className="myl-mt-auto myl-w-full myl-bg-gray-5 myl-px-8 myl-py-8 myl-text-gray-1 md:myl-px-24"
    >
      <div>
        Legal: |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/security/">
          Security
        </a>{' '}
        |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/privacy/">
          Privacy
        </a>{' '}
        |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/terms-and-conditions/">
          Terms and Conditions
        </a>{' '}
        |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/gdpr/">
          GDPR Centre
        </a>
      </div>
      <p className="myl-mt-1 myl-font-semibold">
        Safety management software for every business. © {new Date().getFullYear()} myosh.
      </p>
    </footer>
  );
};

export default Footer;
